<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="1000px"
    >
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">Edit Product</h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="toggleModal"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
          <!--begin::Body-->
          <form id="createForm" class="pa-3 pb-0">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <template v-for="n in steps">
                  <v-stepper-step
                    :key="`${n}-step`"
                    :complete="e1 > n"
                    :step="n"
                    editable
                  >
                    <span v-if="n === 1">Settings</span>
                    <span v-if="n === 2">Edit Name</span>
                    <span v-if="n === 3">Edit Description</span>
                    <span v-if="n === 4">Edit Seo</span>
                    <span v-if="n === 5">Edit Image</span>
                  </v-stepper-step>

                  <v-divider v-if="n !== steps" :key="n"></v-divider>
                </template>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content :step="1" :key="`1-content`">
                  <div
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div class="stepper-content">
                      <v-autocomplete
                        v-if="categories"
                        v-model="category_id"
                        :items="categories"
                        outlined
                        item-name="text"
                        item-value="index"
                        dense
                        clearable
                        label="Categories*"
                      ></v-autocomplete>

                      <v-autocomplete
                        v-model="brand_id"
                        :items="brands"
                        :search-input.sync="searchBrand"
                        outlined
                        item-name="text"
                        item-value="index"
                        dense
                        clearable
                        label="Brands"
                        ><template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              To Create this new brand
                              <span class="ml-3"
                                ><v-btn
                                  color="primary"
                                  @click="CreateBrand"
                                  :loading="brandCreateLoading"
                                >
                                  Create
                                </v-btn></span
                              >
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div class="stepper-footer">
                      <div></div>
                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="nextStep(1)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="2" :key="`2-content`">
                  <div
                    v-if="category_id"
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div class="stepper-content">
                      <v-text-field
                        v-for="(item, index) in languages"
                        :key="'name' + index"
                        v-model="formData['name_' + item.index]"
                        :label="'Name(' + item.text + ')*'"
                        required
                        outlined
                        dense
                        clearable
                      ></v-text-field>
                    </div>
                    <div class="stepper-footer">
                      <button
                        type="button"
                        class="btn btn-light mr-3 px-5 py-3 ls1"
                        @click="previewStep(2)"
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="nextStep(2)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="3" :key="`3-content`">
                  <div
                    v-if="category_id"
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div class="stepper-content">
                      <div class="d-flex justify-content-end">
                        <div class="w-25">
                          <v-autocomplete
                            v-if="languages"
                            v-model="description_language"
                            :items="languages"
                            outlined
                            item-name="text"
                            item-value="index"
                            dense
                            clearable
                            label="Language"
                          ></v-autocomplete>
                        </div>
                      </div>
                      <div
                        v-for="(item, index) in languages"
                        :key="'body' + index"
                      >
                        <ckeditor
                          v-model="formData['description_' + item.index]"
                          :config="editorConfig"
                          v-if="description_language === item.index"
                        ></ckeditor>
                      </div>
                    </div>
                    <div class="stepper-footer mt-3">
                      <button
                        type="button"
                        class="btn btn-light mr-3 px-5 py-3 ls1"
                        @click="previewStep(3)"
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="nextStep(3)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="4" :key="`4-content`">
                  <div
                    v-if="category_id"
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div class="stepper-contetnt">
                      <v-text-field
                        v-for="(item, index) in seos"
                        :key="'seo' + index"
                        v-model="formData[item]"
                        :label="'Seo(' + item + ')'"
                        required
                        outlined
                        dense
                        clearable
                      ></v-text-field>
                    </div>

                    <div class="stepper-footer">
                      <button
                        type="button"
                        class="btn btn-light mr-3 px-5 py-3 ls1"
                        @click="previewStep(4)"
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="nextStep(4)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="5" :key="`5-content`">
                  <div
                    v-if="category_id"
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div class="stepper-contetnt">
                      <div v-if="!!formData.uploadedImage">
                        <h4>Uploaded Image</h4>
                        <div
                          v-for="(item, index) in formData.uploadedImage"
                          :key="index"
                          class="d-flex"
                        >
                          <span
                            ><show-image :item="item" class="mr-3"> </show-image
                          ></span>
                          <span
                            ><v-icon left @click="removeUploadedImage(item.id)">
                              mdi-delete
                            </v-icon></span
                          >
                        </div>
                      </div>
                      <div v-if="!!formData.image">
                        <h4>To upload Image</h4>
                        <div
                          v-for="(item, index) in formData.image"
                          :key="index"
                        >
                          <span>{{ item.name }}</span>
                          <span
                            ><v-icon left @click="removeImageItem(index)">
                              mdi-delete
                            </v-icon></span
                          >
                        </div>
                      </div>
                      <cropper
                        :insertImage="insertImage"
                        class="w-100"
                      ></cropper>
                      <v-switch
                        v-model="formData.home_page"
                        color="primary"
                        label="Home Page"
                      />
                    </div>

                    <div class="stepper-footer">
                      <button
                        type="button"
                        class="btn btn-light mr-3 px-5 py-3 ls1"
                        @click="previewStep(5)"
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="submitUpdate"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </form>

          <!--end::Body-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import Cropper from "@/view/pages/plugins/UploadCropper.vue";
import ShowImage from "@/own/components/datatable/ShowImage.vue";
import { UPDATE_CREATE_DATA } from "@/core/services/store/products.module";

export default {
  name: "EditProduct",
  props: [
    "refresher",
    "loader",
    "brands",
    "stores",
    "parameters",
    "itemForAction",
  ],
  components: {
    Cropper,
    ShowImage,
  },
  data: () => ({
    dialog: false,
    tabIndex: 0,
    editorConfig: {},
    name_language: null,
    description_language: null,
    store_id: null,
    category_id: null,
    brand_id: null,
    formData: null,
    searchBrand: null,
    brandCreateLoading: false,
    imageCount: 0,
    e1: 1,
    steps: 5,
    seos: ["keywords", "meta_title", "meta_description"],
  }),
  computed: {
    product_id: function () {
      return this.itemForAction.id;
    },
    categories: function () {
      if (this.stores) {
        let selectedItem = this.stores.filter(
          (item) => item.index === this.itemForAction.store_group.id
        );
        return selectedItem[0].categories;
      }
      return null;
    },
    languages: function () {
      let selectedItem = this.stores.filter(
        (item) => item.index === this.itemForAction.store_group.id
      );
      return selectedItem[0].languages;
    },
  },
  methods: {
    toggleModal() {
      if (this.dialog) this.resetData();
      this.getEditData();
      this.dialog = !this.dialog;
    },
    closeModal() {
      this.resetData();
      this.dialog = false;
    },
    getEditData() {
      this.loader(true);
      const editUrl = `${process.env.VUE_APP_BASE_URL}/stores/portal/products/edit`;
      const data = { product_id: this.product_id };
      ApiService.post(editUrl, data)
        .then((data) => {
          this.loader(false);
          this.formData.uploadedImage = data.data.product.cover_image;
          Object.keys(data.data.seo).map((item) => {
            this.formData[item] = data.data.seo[item];
          });
        })
        .catch(() => {
          this.brandCreateLoading = false;
          this.loader(false);
        });
    },
    removeUploadedImage(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loader(true);
          const data = { image_id: id };
          ApiService.post("/stores/portal/products/images/destroy", data)
            .then(() => {
              this.formData.uploadedImage = this.formData.uploadedImage.filter(
                (item) => item.id !== id
              );
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              this.loader(false);
              this.refresher();
            })
            .catch(() => {
              this.loader(false);
            });
        }
      });
    },
    converFormData() {
      let data = new FormData();
      data.append("product_id", this.product_id);
      data.append("category_id", this.category_id);
      data.append("brand_id", this.brand_id);
      for (let key in this.formData) {
        if (this.formData[key]) {
          if (key === "home_page") {
            if (this.formData[key] === true) data.append(key, 1);
            else data.append(key, 0);
          } else if (key === "image") {
            this.formData[key].map((item) => {
              data.append("cover_images[]", item.image);
            });
          } else data.append(key, this.formData[key]);
        } else {
          if (key === "home_page") {
            if (this.formData[key] === false) data.append(key, 0);
          } else {
            return null;
          }
        }
      }
      return data;
    },
    insertImage(image) {
      this.formData.image.push(image);
    },
    CreateBrand() {
      if (!this.searchBrand) {
        this.errorMessage("Please input new Search Brand");
      }
      this.brandCreateLoading = true;
      const createBrandUrl = `${process.env.VUE_APP_BASE_URL}/stores/portal/brands/store`;
      const data = { title: this.searchBrand };
      ApiService.post(createBrandUrl, data)
        .then(() => {
          Swal.fire({
            title: "Created",
            text: `The Brand has been Created`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.$store.dispatch(UPDATE_CREATE_DATA, {}).then(() => {
            this.brandCreateLoading = false;
          });
          this.$forceUpdate();
        })
        .catch(() => {
          this.brandCreateLoading = false;
          this.loader(false);
        });
    },
    submitUpdate() {
      const data = this.converFormData();
      if (!data) {
        return;
      }
      this.loader(true);
      const updateUrl = `${process.env.VUE_APP_BASE_URL}/stores/portal/products/update`;
      ApiService.post(updateUrl, data)
        .then(() => {
          this.loader(false);
          swalEdited();
          this.toggleModal();
          this.refresher();
          this.$forceUpdate();
        })
        .catch(() => {
          this.loader(false);
        });
    },
    errorMessage(message) {
      Swal.fire({
        title: "Error",
        text: message,
        icon: "error",
        showConfirmButton: false,
        timer: 2500,
      });
    },
    resetData() {
      this.formData = null;
      this.category_id = this.itemForAction.category.id;
      this.brand_id = this.itemForAction.brand.id;
      this.formData = {
        image: [],
        uploadedImage: [],
        home_page: this.itemForAction.home_page_label === "Yes" ? 1 : 0,
      };
      this.languages.map((item) => {
        this.formData["name_" + item.index] =
          this.itemForAction.name[item.index];
        this.formData["description_" + item.index] =
          this.itemForAction.description[item.index];
      });
      this.nextStep(5);
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        if (n === 1) {
          if (!this.category_id)
            this.errorMessage("Should Complete these all field!");
          else this.e1 = n + 1;
        } else if (n === 2) {
          let test = true;
          this.languages.map((item) => {
            if (
              !this.formData["name_" + item.index] ||
              this.formData["name_" + item.index] == ""
            ) {
              test = false;
              return;
            }
          });
          if (test) {
            this.e1 = n + 1;
            this.description_language = this.languages[0].index;
          } else
            this.errorMessage("Should Complete Name data in all languages!");
        } else if (n === 3) {
          let descriptionTest = true;
          this.languages.map((item) => {
            if (
              !this.formData["description_" + item.index] ||
              this.formData["description_" + item.index] == ""
            ) {
              descriptionTest = false;
              return;
            }
          });
          if (descriptionTest) this.e1 = n + 1;
          else
            this.errorMessage(
              "Should Complete Description data in all languages!"
            );
        } else this.e1 = n + 1;
      }
    },
    createFormData() {},
    removeImageItem(index) {
      this.formData.image = this.formData.image.filter(
        (item, key) => key !== index
      );
    },
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },
};
</script>
